import Component from "@ember/component";

export default Component.extend({
  tagName: null,
  href: null,
  title: null,
  ariaLabel: null,
  shouldShow: null,
});
